export default __webpack_public_path__ + "static/media/welcomeInfo.dc3db3f9.png";